module.exports = __webpack_public_path__ + "img/orderConfirm.c98b9872.svg";